import PlaceholderPage from '../components/PlaceholderPage';

export default function IdentityCoE() {
  return (
    <PlaceholderPage
      eyebrow="Identity CoE"
      title="The Identity Security Centre of Excellence"
      subtitle="Architecture. Governance. Trust. Resilience. This page can be expanded next with the full operating model (four pillars), comparison tables, and reference architecture preview from your spec."
      primaryCtaLabel="Request Identity CoE Assessment"
    />
  );
}
